/**
 * Module pour le chatbot
 */
angular
  .module('chatbotModule', [])
  .filter('trustHtml', trustHtmlFilter)
  .directive('chatbot', chatbotDirective);

trustHtmlFilter.$inject = ['$sce'];
chatbotDirective.$inject = [];

/**
 * Filtre pour afficher du HTML en toute sécurité
 * @param {Service} $sce - Service $sce d'Angular
 * @returns {Function} - Fonction de filtre
 */
function trustHtmlFilter($sce) {
  return function(text) {
    return $sce.trustAsHtml(text);
  };
}

/**
 * Directive pour insérer le chatbot n'importe où dans l'application
 * @returns {Object} - Configuration de la directive
 */
function chatbotDirective() {
  return {
    restrict: 'E',
    templateUrl: 'app/shared/chatbot/chatbot.html',
    controller: 'ChatbotController',
    controllerAs: 'vm',
    scope: {}
  };
}
